import { useRef, useCallback } from 'react';
import { focusOption } from '../Dropdown/utils/focusOption';
import { stopEvent } from '../utils/stopEvent';
var focusMatchingOption = function (options) {
    var activeIndex = options.indexOf(document.activeElement);
    var nextMatch = options[activeIndex + 1];
    if (activeIndex !== -1 && nextMatch) {
        focusOption(nextMatch === null || nextMatch === void 0 ? void 0 : nextMatch.parentElement, nextMatch);
        return;
    }
    var option = options[0];
    focusOption(option === null || option === void 0 ? void 0 : option.parentElement, option);
};
export var useDropdownKeyboardSupport = function () {
    // Options ref can also contain undefined in case the options count has changed after rerender
    var optionsRef = useRef([]);
    var cumulativeSearchRef = useRef({ search: '' });
    var onKeyDown = useCallback(function (event) {
        var key = event.key;
        if (key === 'ArrowDown') {
            stopEvent(event);
            var option = optionsRef.current[0];
            focusOption(option === null || option === void 0 ? void 0 : option.parentElement, option);
            return;
        }
        // Ignore multi character keys (e.g. Tab, ArrowUp, etc)
        if (key.length > 1) {
            return;
        }
        stopEvent(event);
        var _a = cumulativeSearchRef.current, search = _a.search, timeout = _a.timeout;
        if (timeout) {
            clearTimeout(timeout);
        }
        var newSearch = "".concat(search).concat(key);
        cumulativeSearchRef.current = {
            search: newSearch,
            timeout: setTimeout(function () {
                cumulativeSearchRef.current.search = '';
            }, 350)
        };
        var matchingOptions = optionsRef.current.filter(function (node) {
            return (node === null || node === void 0 ? void 0 : node.innerText.trim().slice(0, newSearch.length).localeCompare(newSearch, undefined, { sensitivity: 'base' })) === 0;
        });
        focusMatchingOption(matchingOptions);
    }, []);
    return { onKeyDown: onKeyDown, optionsRef: optionsRef };
};
//# sourceMappingURL=useDropdownKeyboardSupport.js.map